import axios from "axios";
import {baseApiUrl } from "@/utils";


console.log(baseApiUrl)
export default (url = `${baseApiUrl}`) => {

    return axios.create({
        baseURL: url,
        headers: {
            'Accept': 'application/json',
        },
    });
}

export function performRequest(endpoint, {query = null } = {}) {
    const args = []

    if(query) args.push(query)


    return new Promise((resolve, reject) => {

        endpoint(...args)
            .then(response => {
                resolve(response.data)
            })
            .catch(error => {
                console.error('Something went wrong', error);
                reject(error);  // Forward the error
            });
    });
}
